// Контакт для связи — телефон (от 10 цифр: пробелы, скобки, дефисы и «+» не мешают) или почта.
// То же правило проверяет сервер (server/app.mjs, isContact)
export const isContact = (value: unknown): boolean =>
  typeof value === 'string' &&
  (value.replace(/\D/g, '').length >= 10 || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()));
